export class User {
  constructor(data) {
    this.id = -1;
    this.name = "Guest";
    this.email = "guest@skymapglobal.com";
    this.avatar = undefined;
    this.created_at = "2017-06-08 00:00:00";
    this.updated_at = "2017-06-08 00:00:00";
    this.mobile = "Default Guest";
    this.department = undefined;
    this.roles = [
      {
        id: 4,
        name: "Guest",
        all: false,
        sort: 4,
        created_at: "2017-06-08 07:10:22",
        updated_at: "2017-06-08 07:10:22",
        permissions: []
      }
    ];
    this.uuid = undefined;
    this.position = undefined;
    this.platform = undefined;
    this.manager_departments = [];

    if (data) this.update(data);
  }

  get permissions() {
    return this.roles.reduce(
      (permissions, role) => permissions.concat(role.permissions),
      []
    );
  }

  get isAdmin() {
    for (const role of this.roles) {
      if (role.all) return true;
    }

    return false;
  }

  update(data) {
    this.id = data["id"];
    this.name = data["name"];
    this.email = data["email"];
    this.avatar = data["avatar"];
    this.created_at = data["created_at"];
    this.updated_at = data["updated_at"];
    this.mobile = data["mobile"];
    this.roles = data["roles"];
    this.department = data["department"];
    this.uuid = data["uuid"];
    this.position = data["position"];
    this.platform = data["platform"];
    this.manager_departments = data["manager_departments"];
  }

  hasRole(role) {
    for (const r of this.roles) {
      if (typeof role === "string") {
        if (r.name === role) {
          return true;
        }
      } else {
        if (r.id === role) {
          return true;
        }
      }
    }

    return false;
  }

  hasRoles(roles) {
    for (const role of roles) {
      if (this.hasRole(role)) {
        return true;
      }
    }

    return false;
  }

  hasAllRoles(roles) {
    for (const role of roles) {
      if (!this.hasRole(role)) {
        return false;
      }
    }

    return true;
  }

  hasPermission(permission) {
    if (this.isAdmin) return true;

    for (const p of this.permissions) {
      if (typeof permission === "string") {
        if (p.name === permission) {
          return true;
        }
      } else {
        if (p.id === permission) {
          return true;
        }
      }
    }

    return false;
  }

  hasPermissions(permissions) {
    if (this.isAdmin) return true;

    for (const permission of permissions) {
      if (this.hasPermission(permission)) {
        return true;
      }
    }

    return false;
  }

  hasAllPermissions(permissions) {
    if (this.isAdmin) return true;

    for (const permission of permissions) {
      if (!this.hasPermission(permission)) {
        return false;
      }
    }

    return true;
  }
}
